export default "/_next/static/images/304ee560b265f768a29cbddba15ebab6.svg";